import { Grid, Stack } from '@mui/material';

import EmLevelInput from './EmLevelInput';

type PctCasesVal = {
  [index: string]: string | number;
};
export default function PctAppCases({
  onChange,
  value = {},
}: {
  onChange?: (v: PctCasesVal) => void;
  value?: PctCasesVal;
}) {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let tempObj = { ...value };
    let val = e.target.value?.trim?.();
    let targetVal = '';
    if (val !== '') {
      const numberVal = Math.round(Number(val));
      targetVal = String(
        numberVal >= 100 ? 100 : numberVal <= 0 ? 0 : numberVal
      );
    }
    tempObj = { ...tempObj, [e.target.name]: targetVal };

    onChange?.(tempObj);
  };

  return (
    <Grid container spacing={2}>
      <Grid xs={6} item>
        <Stack direction="column" spacing={1}>
          <EmLevelInput
            onChange={handleInputChange}
            name="99281"
            id="99281"
            key={99281}
            value={value?.['99281'] ?? ''}
          />
          <EmLevelInput
            onChange={handleInputChange}
            name="99282"
            id="99282"
            key={99282}
            value={value?.['99282'] ?? ''}
          />
          <EmLevelInput
            onChange={handleInputChange}
            name="99283"
            id="99283"
            key={99283}
            value={value?.['99283'] ?? ''}
          />
        </Stack>
      </Grid>
      <Grid xs={6} item>
        <Stack direction="column" spacing={1}>
          <EmLevelInput
            onChange={handleInputChange}
            name="99284"
            id="99284"
            key={99284}
            value={value?.['99284'] ?? ''}
          />
          <EmLevelInput
            onChange={handleInputChange}
            name="99285"
            id="99285"
            key={99285}
            value={value?.['99285'] ?? ''}
          />
          <EmLevelInput
            onChange={handleInputChange}
            name="99291"
            id="99291"
            key={99291}
            value={value?.['99291'] ?? ''}
          />
        </Stack>
      </Grid>
    </Grid>
  );
}
